import { render, staticRenderFns } from "./PiDivTable.vue?vue&type=template&id=5a5c51f8&scoped=true"
import script from "./PiDivTable.vue?vue&type=script&lang=js"
export * from "./PiDivTable.vue?vue&type=script&lang=js"
import style0 from "./PiDivTable.vue?vue&type=style&index=0&id=5a5c51f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c51f8",
  null
  
)

export default component.exports